import { render, staticRenderFns } from "./CardPlace.vue?vue&type=template&id=06921a4a&scoped=true"
import script from "./CardPlace.vue?vue&type=script&lang=js"
export * from "./CardPlace.vue?vue&type=script&lang=js"
import style0 from "./CardPlace.vue?vue&type=style&index=0&id=06921a4a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06921a4a",
  null
  
)

export default component.exports